import { AddWifiDto } from '../settings/wifi';
import { SortDirection } from '../types';

export type AppStateDevicesState = {
    devices: DeviceData;
    isLoading: boolean;
    settingsVitals: {
        searchValue: string;
        sort: DevicesSorting;
        filters: DeviceFilterMap;
        selectedDevices: string[];
    };
    settingsBiopatch: {
        searchValue: string;
        sort: DevicesSorting;
        filters: DeviceFilterMap;
        selectedDevices: string[];
    };
    settingsWatch: {
        searchValue: string;
        sort: DevicesSorting;
        filters: DeviceFilterMap;
        selectedDevices: string[];
    };
    settingsUserTag: {
        searchValue: string;
        sort: DevicesSorting;
        filters: DeviceFilterMap;
        selectedDevices: string[];
    };
    roomBedChangeSuccess: boolean;
};
export type DevicesSorting = {
    direction: SortDirection;
    type: DevicesSortType;
};

export enum DevicesSortType {
    RoomBed = 'RoomBed',
    Id = 'Id',
    Block = 'Block',
}
export type DeviceData = {
    [key: string]: Device;
};

export type DeviceFilterMap = {
    [key in DeviceFilter]?: boolean;
};

export enum DeviceFilter {
    ACTIVE = 'DEVICE ACTIVE',
    NOT_ACTIVE = 'DEVICE NOT ACTIVE',
    ROOM_BED_YES = 'ROOM_BED_YES',
    ROOM_BED_NO = 'ROOM_BED_NO',
    RESIDENT_YES = 'RESIDENT_YES',
    RESIDENT_NO = 'RESIDENT_NO',
    UNPLUGGED = 'UNPLUGGED',
    MAINTENANCE = 'MAINTENANCE',
    BATTERY_CHARGING = 'BATTERY_CHARGING',
    BatteryLevelLow = 'BatteryLevelLow',
    BatteryLevelEmpty = 'BatteryLevelEmpty',
    LOW_WIFI = 'lowWifi',
    NO_WIFI = 'noWifi',
    NO_BLUETOOTH = 'NO_BLUETOOTH',
    PUMP_YES = 'PUMP_YES',
    PUMP_NO = 'PUMP_NO',
    PIR_YES = 'PIR_YES',
    PIR_NO = 'PIR_NO',
    TURN_OFF = 'turnOff',
    USER_NEARBY_IN_BED = 'userNearbyInBed',
    USER_NEARBY_OUT_BED = 'userNearbyOutBed',
    USER_NEARBY_ROOM = 'userNearbyOutRoom',
}

export type DevicesSettings = {
    sort?: DevicesSorting;
    searchValue?: string;
    filters?: DeviceFilterMap;
    selectedDevices?: string[];
};

export enum deviceInclude {
    statuses = 'statuses',
    residents = 'residents',
    nodes = 'nodes',
}

export type devicesReqOptions = {
    [key: string]: number | string | deviceInclude[];
    include: deviceInclude[];
    filterBy?: string;
};

export const defaultOptions: devicesReqOptions = {
    include: [deviceInclude.residents, deviceInclude.nodes],
};

export enum DeviceType {
    vitals = 'vitals',
    biopatch = 'biopatch',
    watch = 'watch',
    userTag = 'userTag',
}

export enum DeviceName {
    vitals = 'Vitals',
    biopatch = 'BioPatch',
    watch = 'Watch',
    tag = 'User Tag',
}

export type DeviceUpdateDTO = {
    nodeId: number;
    room: string;
    hasPump: boolean;
    bed: string;
    id: string;
    deleteResident?: boolean;
    residentId?: string;
};

export type DeviceMoveDTO = {
    nodeId: number;
    hasPump: boolean;
    id: string;
    type: DeviceType;
    room?: string;
    bed?: string;
    residentId?: string;
};

export type DeviceSocketUpdateDTO = {
    nodeId: number;
    room: string;
    hasPump: boolean;
    bed: string;
    id: string;
    resident: string | null;
    type: DeviceType;
    statuses: any;
};

export type DeviceDeleteLinkAndUpdateDTO = {
    nodeId: number;
    room: string;
    bed: string;
    id: string;
    residentId: string;
    type: DeviceType;
};

export type DeviceResidentDTO = {
    deviceId: string;
    residentId: string;
};

export type ADDDeviceResidentDTO = {
    deviceId: string;
    residentId: string;
    deviceType: string;
    bed: string;
    room: string;
};

export interface Device {
    residentId?: string;
    userId?: string;
    nodeId: number;
    type: DeviceType;
    room?: string;
    bed?: string;
    hasPump?: boolean;
    id: string;
    mac?: string;
    continuesDetectionTime?: number;
}

export type userTagSettingsDTO = {
    userId: string;
    productId: string;
    continuesDetectionTime: number;
};

export type userTagUpdateSocketDTO = {
    continuesDetectionTime: number;
    deviceId: string;
    id: string;
    nodeId: string;
};

export type changeDevicesWiFiDTO = AddWifiDto & {
    devicesIds: string[];
};
